
const digest = '77e21ab78d9f29a5c82c7283a9f5d7b9dec67a96861039c8ded2ca8a89a96966';
const css = `._wordCountContainer_8si3i_1 {
  width: 300px;
  max-width: 100%;
  font-size: var(--font-size-100);
}

._wordCountRow_8si3i_7 {
  display: flex;
  justify-content: space-between;
  padding: var(--spacer-3) 0;
}

._wordCountRow_8si3i_7 ~ ._wordCountRow_8si3i_7 {
  border-top: 1px solid var(--theme-primary-border);
}

._wordCount_8si3i_1 {
  margin-right: var(--spacer-3);
}

._count_8si3i_21 {
  font-weight: 600;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"wordCountContainer":"_wordCountContainer_8si3i_1","wordCountRow":"_wordCountRow_8si3i_7","wordCount":"_wordCount_8si3i_1","count":"_count_8si3i_21"};
export { css, digest };
  